import { defineStore } from 'pinia'
import type { IProfileParams } from '@ui/interfaces/hotel'

export interface IAnnouncement {
  announcement_id: number
  title: string | null
  image: string
  status: string
  start_date: string | null
  end_date: string | null
  cta: string | null
  hotel_id: string
}

export interface IHotel {
  hotel_title: string
  hotel_category: string | null
  hotel_description: string
  hotel_image: string | null
  hotel_id: string
}
export interface IFacilityIcon {
  preset_facility_name: string
  icon_label: string
  icon_image: string
  icon_text: string
  category: string
}

const DATA_ANNOUNCEMENT: IAnnouncement = []

const DATA_PROFILE: IProfileParams = {
  hotel_id: 0,
  app_id: '',
  city_id: 0,
  hotel_name: '',
  hotel_logo: '',
  hotel_logo_color: '',
  hotel_phone: '',
  hotel_whatsapp: '',
  hotel_email: '',
  hotel_address: '',
  hotel_tawtko: '',
  hotel_website: '',
  hotel_geo: '',
  latitude: '',
  longitude: '',
  hotel_simplebooking: '',
  simplebooking_id: 0,
  hotel_currency: '',
  hotel_rate: '',
  hotel_status: '',
  hotel_order: 0,
  simplebooking_user: '',
  simplebooking_pass: '',
  xml_user: '',
  xml_pass: '',
  powered_by: '',
  gtag_id: '',
  codebuild_name: '',
  hotel_lang_id: 0,
  lang_id: 0,
  hotel_text: '',
  text_about: '',
  text_footer: '',
  headline_about: '',
  headline_rooms: '',
  headline_news: '',
  headline_facility: '',
  headline_offers: '',
  headline_meeting: '',
  headline_gallery: '',
  m_title: '',
  m_description: '',
  facilities_icon: [],
  thumbnail_desktop: '',
  hotel_favicon: '',
  ota_url: '',
  primary_font_url: '',
  secondary_font_url: '',
  tripadvisor_url: '',
  google_map_link: '',
}
export interface IHotelState {
  list: Array<IHotel>
  loading: boolean
  profile: IProfileParams
  announcement: IAnnouncement
}

export const useHotelStore = defineStore('hotel', {
  state: (): IHotelState => ({
    list: [],
    profile: DATA_PROFILE,
    loading: false,
    announcement: DATA_ANNOUNCEMENT,
  }),
  getters: {
    getList(): IHotelState['list'] {
      return this.list
    },
    getLoading(): IHotelState['loading'] {
      return this.loading
    },
    getProfile(): IHotelState['profile'] {
      return this.profile
    },
    getAnnouncement(): IHotelState['announcement'] {
      return this.announcement
    },
  },
  actions: {
    async setList(data: IHotel[]) {
      this.list = data
    },
    async setProfile(data: IProfileParams) {
      this.profile = data
    },
    async setAnnouncement(data: IAnnouncement) {
      this.announcement = data
    },
  },
})
